import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './combineReducers'

const initialState = {}
const enhancers = []
const middleware = [thunk]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

store.subscribe(() => {
  const access_token = store.getState().auth.access_token
  const user = store.getState().auth.user

  localStorage.setItem('SARAFAN_ADMIN_ACCESS_TOKEN', access_token)
  localStorage.setItem('SARAFAN_ADMIN_USER', JSON.stringify(user))
})

export default store



// WEBPACK FOOTER //
// ./src/redux/store.js